import { hydrateChainRegistry, listChainRegistryEntries } from '@shared/chainRegistryClient'
import type { ChainRegistryEntry, ChainRegistryRaw } from '@shared/chainRegistryTypes'
import { apiClient } from '@/utils/apiClient'

let chainRegistryRequestId = 0

interface ChainsApiResponse {
  success: boolean
  data?: {
    chains: ChainRegistryRaw[]
  }
  error?: {
    message?: string
  }
}

export const loadChainRegistry = async (
  testnetOnly: boolean = true
): Promise<{ chains: ChainRegistryEntry[] } | null> => {
  const requestId = ++chainRegistryRequestId
  const params = testnetOnly ? { testnet: 'true' } : undefined

  try {
    const response = await apiClient.get<ChainsApiResponse>('/admin/chains-tokens', { params })
    if (requestId !== chainRegistryRequestId) {
      return null
    }
    const payload = response.data
    if (!payload.success || !payload.data?.chains) {
      return {
        chains: listChainRegistryEntries(),
      }
    }

    const hydrated = hydrateChainRegistry(payload.data.chains)
    return {
      chains: hydrated,
    }
  } catch (error) {
    if (requestId !== chainRegistryRequestId) {
      return null
    }
    throw error
  }
}
